import React from "react";

// This component is used to wrap a component that is used in a List or Edit
// view. It is used to remove the basePath prop that is passed to the component
// by react-admin. This is useful when you want to reuse a component in a
// different context than the one it was designed for.
const NoBasePath = React.memo(({ children }) => children);

export default NoBasePath;
